import React from 'react'
import {FAQAccordion} from '../partials/accordion'
import CustomerServiceLayoutDefault from '../layout/default'
import useCustomerServicePageConfig from '../../../../app/pages/customer-service/hooks/use-page-config'
import CSHeader from '../../../../app/pages/customer-service/partials/header'

const CustomerServiceSubPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {name, description, content} = pageConfig
    const data = content.params.items
    return (
        <CustomerServiceLayoutDefault>
            <CSHeader headline={name} subline={description}></CSHeader>
            <FAQAccordion data={data} />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceSubPage
